<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="uniqueId"
        slim
        v-slot="{ validated, valid, errors }"
    >
        <rkm-form-group
            :class="{ 'placeholder-label': label === false }"
            :invalid-feedback="errors[0]"
            :label="label ? (label + (rules && rules.required ? ' *' : '')) : null"
            :state="rules ? (validated ? valid : null) : null"
        >
            <rkm-input-group
                :append="append"
                :prepend="prepend"
            >
                <template
                    v-if="!prepend && $slots.prepend"
                    slot="prepend"
                >
                    <slot name="prepend" />
                </template>

                <b-form-select
                    :disabled="disabled"
                    :multiple="multiple"
                    :options="options"
                    :state="rules ? (validated ? valid ? null : false : null) : null"
                    :text-field="textField"
                    :value-field="valueField"
                    :value="value"
                    @change="$emit('change', $event)"
                    @input="$emit('input', $event)"
                >
                    <template v-if="showDefaultOption">
                        <rkm-form-select-option
                            :value="null"
                            slot="first"
                        >
                            {{ defaultOptionText }}
                        </rkm-form-select-option>
                    </template>

                    <slot
                        v-else
                        name="first"
                        slot="first"
                    />

                    <slot />
                </b-form-select>

                <template
                    v-if="!append && $slots.append"
                    slot="append"
                >
                    <slot name="append" />
                </template>
            </rkm-input-group>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
// Components.
import {BFormSelect} from 'bootstrap-vue'
import {ValidationProvider} from 'vee-validate'

// Mixins.
import {string} from './../mixins'

export default {
    components: {BFormSelect, ValidationProvider},
    computed: {
        rules() {
            return this.disabled ? null : this.validations
        },
    },
    mixins: [string],
    props: {
        append: {type: String},
        defaultOptionText: {type: String, default: 'Selecione'},
        disabled: {type: Boolean},
        label: {type: [String, Boolean], default: ''},
        multiple: {type: Boolean},
        name: {type: String},
        options: {type: [Array, Object], default: () => []},
        prepend: {type: String},
        showDefaultOption: {type: Boolean},
        textField: {type: String, default: 'nome'},
        validationMode: {type: String, default: 'lazy'},
        validations: {type: Object},
        value: {type: [Array, Boolean, Number, Object, String], default: null},
        valueField: {type: String, default: 'id'},
    },
}
</script>